enum AreaContainerPremission {
  Prem_Area_Container_Create = 'Prem_Area_Container_Create',
  Prem_Area_Container_Edit = 'Prem_Area_Container_Edit',
  Prem_Area_Container_View = 'Prem_Area_Container_View',
  Prem_Area_Container_Delete = 'Prem_Area_Container_Delete',
}

export default AreaContainerPremission;
